export var BalanceRetrieveRecordStatus;
(function (BalanceRetrieveRecordStatus) {
    BalanceRetrieveRecordStatus["PROCESSING"] = "processing";
    BalanceRetrieveRecordStatus["FAILURE"] = "failure";
    BalanceRetrieveRecordStatus["SUCCESS"] = "success";
})(BalanceRetrieveRecordStatus || (BalanceRetrieveRecordStatus = {}));
//# sourceMappingURL=BalanceRetrieveRecordStatus.js.map